<!-- <app-home></app-home> -->
<app-pagenotfound *ngIf="error == 'ACCESS_DENIED'; else GPNav"></app-pagenotfound>

<ng-template #GPNav>
    <mat-sidenav-container class="side-draw-container" hasBackdrop="true">
        <mat-sidenav mode="over" position="end" class="portal-detail-drawer-host portal-detail-drawer-host--task"
            [opened]="this.pontoBankTransactionsService.openTransactionDrawerFlag.value"
            [autoFocus]="false" (closed)="this.pontoBankTransactionsService.closeDrawer()">
                <app-ponto-bank-transaction-detail></app-ponto-bank-transaction-detail>
        </mat-sidenav>
        <mat-sidenav-content class="side-draw-content">
            <mat-sidenav-container class="side-draw-container" hasBackdrop="true">
                <mat-sidenav mode="over" position="end" class="portal-detail-drawer-host portal-detail-drawer-host--invoice invoice-details-side-nav"
                    [opened]="this.invoiceDetailService.openInvoiceDetail.value" [autoFocus]="false"
                    (closed)="this.invoiceDetailService.closeInvoiceDetailDrawer()" [@.disabled]="true">
                    <app-invoice-detail *ngIf="this.invoiceDetailService.openInvoiceDetail.value"></app-invoice-detail>
                </mat-sidenav>
                <mat-sidenav-content class="side-draw-content">
                    <mat-sidenav-container class="side-draw-container" hasBackdrop="true">
                        <mat-sidenav mode="over" position="end"
                            [opened]="this.portfolioService.openPortfolioDrawerFlag.value" [autoFocus]="false"
                            (closed)="this.portfolioService.closePortfolioDrawer()">
                            <app-add-company></app-add-company>
                        </mat-sidenav>
                        <mat-sidenav-content class="side-draw-content">
                            <mat-sidenav-container class="side-draw-container" hasBackdrop="true">
                                <mat-sidenav mode="over" position="end" class="portal-detail-drawer-host portal-detail-drawer-host--task management-task-drawer"
                                    [opened]="this.managementService.openDrawerFlag.value" [autoFocus]="false"
                                    (closed)="this.managementService.closeDrawer()">
                                    <app-task-details></app-task-details>
                                </mat-sidenav>
                                <mat-sidenav-content class="side-draw-content">
                                    <mat-sidenav-container class="side-draw-container" hasBackdrop="true">
                                        <mat-sidenav mode="over" position="end" class="portal-detail-drawer-host portal-detail-drawer-host--counterpart counterpart-details-side-nav"
                                            [opened]="this.counterpartDetailService.openDrawerFlag.value"
                                            [autoFocus]="false" (closed)="this.counterpartDetailService.closeDrawer()">
                                            <app-counterpart-side-draw
                                                *ngIf="this.counterpartDetailService.openDrawerFlag.value"></app-counterpart-side-draw>
                                        </mat-sidenav>
                                        <mat-sidenav-content class="side-draw-content">
                                            <app-home *ngIf="isAuthenticated"></app-home>
                                        </mat-sidenav-content>
                                    </mat-sidenav-container>
                                </mat-sidenav-content>
                            </mat-sidenav-container>
                        </mat-sidenav-content>
                    </mat-sidenav-container>
                </mat-sidenav-content>
            </mat-sidenav-container>
        </mat-sidenav-content>
    </mat-sidenav-container>
</ng-template>
